import { Component, type ReactNode } from "react";

/** Ошибка загрузки отдельного экрана не убирает меню и возможность перейти дальше. */
export class RouteBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="mk-error" role="alert">
        <p>
          Не удалось открыть раздел. Обновите страницу, чтобы повторить
          загрузку.
        </p>
        <button className="mk-button" onClick={() => window.location.reload()}>
          Обновить страницу
        </button>
      </div>
    );
  }
}
